import { useTheme } from "next-themes"
import { Toaster as Sonner, toast as sonnerToast } from "sonner"
import { X } from "lucide-react"

type ToasterProps = React.ComponentProps<typeof Sonner>

// Custom toast wrapper with proper close button
const customToast = {
  error: (message: string, options?: any) => {
    return sonnerToast.error(message, {
      ...options,
      action: {
        label: <X className="h-4 w-4" />,
        onClick: () => sonnerToast.dismiss(),
      },
    })
  },
  success: (message: string, options?: any) => {
    return sonnerToast.success(message, {
      ...options,
      action: {
        label: <X className="h-4 w-4" />,
        onClick: () => sonnerToast.dismiss(),
      },
    })
  },
  info: (message: string, options?: any) => {
    return sonnerToast.info(message, {
      ...options,
      action: {
        label: <X className="h-4 w-4" />,
        onClick: () => sonnerToast.dismiss(),
      },
    })
  },
  warning: (message: string, options?: any) => {
    return sonnerToast.warning(message, {
      ...options,
      action: {
        label: <X className="h-4 w-4" />,
        onClick: () => sonnerToast.dismiss(),
      },
    })
  },
}

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      duration={3000}
      closeButton={false}
      richColors={false}
      expand={true}
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:absolute group-[.toast]:right-3 group-[.toast]:top-3 group-[.toast]:p-1.5 group-[.toast]:rounded-md group-[.toast]:text-muted-foreground/60 group-[.toast]:hover:text-foreground group-[.toast]:hover:bg-muted/50 group-[.toast]:transition-colors group-[.toast]:duration-150 group-[.toast]:w-6 group-[.toast]:h-6 group-[.toast]:flex group-[.toast]:items-center group-[.toast]:justify-center group-[.toast]:border-0 group-[.toast]:bg-transparent group-[.toast]:hover:bg-muted/50",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  )
}

export { Toaster, customToast as toast }
